module.exports = __webpack_public_path__ + "static/media/Like a Feather.0216b5ae.jpg";